"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _ButtonConstants = require("./ButtonConstants");

var _Functions = require("../core/Functions");

var _UIButton = _interopRequireDefault(require("./UIButton"));

var _default = _react.default.createClass({
  displayName: "UIFileButton",
  propTypes: {
    accept: _react.PropTypes.array.isRequired,
    children: _react.PropTypes.node.isRequired,
    multiple: _react.PropTypes.bool.isRequired,
    onChange: _react.PropTypes.func.isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      accept: [],
      multiple: false,
      use: 'tertiary-light'
    };
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;
    (0, _reactDom.findDOMNode)(this._file).click();
    (0, _Functions.callIfPossible)(onClick, evt);
  },
  fileRefCallback: function fileRefCallback(ref) {
    this._file = ref;
  },
  render: function render() {
    var _this$props = this.props,
        accept = _this$props.accept,
        children = _this$props.children,
        id = _this$props.id,
        multiple = _this$props.multiple,
        onChange = _this$props.onChange,
        __onClick = _this$props.onClick,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["accept", "children", "id", "multiple", "onChange", "onClick", "use"]);
    return _react.default.createElement("span", {
      className: "private-file-button"
    }, _react.default.createElement(_UIButton.default, (0, _extends2.default)({
      "data-component-name": "UIFileButton",
      onClick: this.handleClick,
      use: use
    }, rest), children), _react.default.createElement("input", {
      className: "hidden",
      id: id,
      ref: this.fileRefCallback,
      type: "file",
      accept: accept.join(','),
      multiple: multiple,
      onChange: onChange
    }));
  }
});

exports.default = _default;
module.exports = exports.default;